export default {
    cantico: {
      title: 'Il Cantico delle Creature',
      subtitle: 'di San Francesco d\'Assisi',
      headerOriginal: 'Lingua originale del 1225',
      headerTranslations: 'Versione in italiano',
      text: `Altissimo, onnipotente, buon Signore tue sono le
lodi, la gloria e l’onore ed ogni benedizione. A te
solo, Altissimo, fanno riferimento, e nessun uomo è
degno di te.

Laudato sii, o mio Signore, per tutte le creature,
specialmente per messer Fratello Sole, il quale porta
il giorno che ci illumina ed esso è bello e raggiante
con grande splendore: di te, Altissimo, porta
significato.

Laudato sii, o mio Signore, per sorella Luna e le
Stelle: in cielo le hai formate limpide, belle e
preziose.

Laudato sii, o mio Signore, per fratello Vento e per
l’Aria, le Nuvole, il Cielo sereno ed ogni tempo per il
quale alle tue creature dai sostentamento.

Laudato sii, o mio Signore, per sorella Acqua, la
quale è molto utile, umile, preziosa e pura.

Laudato sii, o mio Signore, per fratello Fuoco, con il
quale ci illumini la notte: ed esso è robusto, bello,
forte e allegro.

Laudato sii, o mio Signore, per nostra Madre Terra,
la quale ci sostenta e governa e produce diversi frutti
con coloriti fiori ed erba.

Laudato sii, o mio Signore, per quelli che perdonano
per amor tuo e sopportano malattia e sofferenza.
Beati quelli che le sopporteranno in pace perché da te
saranno incoronati.

Laudato sii, o mio Signore, per nostra sorella Morte
corporale, dalla quale nessun uomo vivente può
scampare. Guai a quelli che moriranno nel peccato
mortale. Beati quelli che si troveranno nella tua
volontà poiché loro la morte non farà alcun male.

Laudate e benedite il Signore e ringraziatelo e
servitelo con grande umiltà.`
    }
  }